import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-save-mapping-config-dialog',
    templateUrl: './save-mapping-config-dialog.component.html',
    styleUrls: ['./save-mapping-config-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SaveMappingConfigDialogComponent implements OnInit {

  name: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data,
    private dialogRef: MatDialogRef<SaveMappingConfigDialogComponent>) { }

  ngOnInit(): void {
    this.name = this.data.configName ?? 'New Transform Config';
  }

  save(): void {
    this.dialogRef.close({name: this.name});
  }

  cancel(): void {
    this.dialogRef.close();
  }

}
